<template>
  <div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
      <h2 class="shadow" style="float: left;width:100%;">Purchase Premium Picks</h2>
      <div id="package_information" style="display:flex;flex-direction:column;width:100%">
      <div id="sport_dropdown" style="display:block;width:100%">
        <label for="sport">Sport:</label>
        <select name="sport" id="sports" v-model="selectedSport" @change="onSportChange">
          <option value="2343a835-82ae-4b4b-bb50-689912b97571">ALL</option>
          <option value="ba74ccae-1bfb-4a56-92d4-402a33d230bf">NFL</option>
          <option value="a2b8b898-5add-4522-a081-fb1030748310">NCAAF</option>
          <option value="c8695b24-eab6-4ee6-b8ab-d99418df69d6">MLB</option>
          <option value="fe1cf0cd-2368-41aa-aaed-12645fdc3ef9">NBA</option>
          <option value="51352c74-5dcc-4a32-b1b9-385c88e2fee6">NCAAB</option>
          <option value="a93e012c-e29a-49ab-901e-ed5396c87212">NHL</option>
          <option value="572cd870-23f9-41b5-80b3-11e1dd568ab5">UFC</option>
        </select>
      </div>
      <div id="membership_dropdown">
        <label for="membership">Membership:</label>
        <select name="membership" id="memberships" v-model="packageId"  @change="emitSelection">
          <option v-if="dataPackage.special" :value="dataPackage.id" hidden>{{dataPackage.name}}</option>
          <option v-for="(option, index) in packages" :key="index" :value="option.id">{{option.name}}</option>
        </select>
      </div>
      </div>
      <div v-if="errorMessage" style="font-size:16px;color:red">
        {{errorMessage}}
      </div>

      <div class="input">
        <div id="paypal-button-container" class="paypal-button-container"></div>
        <div class="Spacer-module_divider__ewqEj">
          <span>OR</span>
        </div>
        <!-- Containers for card fields hosted by PayPal -->
        <div id="card-form" class="card_container">
          <div id="card-name-field-container"></div>
          <div id="card-number-field-container"></div>
          <div id="card-expiry-field-container"></div>
          <div id="card-cvv-field-container"></div>
          <button id="card-field-submit-button" type="button" v-if="dataPackage" @click="purchase()" :disabled="purchaseDisabled">
            {{buttonText}}
          </button>
        </div>
      </div>
  </div>
  <!-- End Main contents -->

  </div>
</template>

<script>
import Raven from 'raven-js'
import Nav from '../components/Nav.vue'
import PurchaseRepository from '../data/purchase.repository'
import {PACKAGES} from '../constants'

const ALL_SPORTS_ID = '2343a835-82ae-4b4b-bb50-689912b97571'
// Last-resort default when the packages API hasn't loaded; price may be stale
const FALLBACK_PACKAGE = {id: PACKAGES.ALL_MONTH, current_price: '129', sports_id: ALL_SPORTS_ID}

export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      errorMessage: '',
      purchaseDisabled: false,
      selectedSport: '2343a835-82ae-4b4b-bb50-689912b97571'
    }
  },
  mounted () {
    var that = this

    function _routeToSuccess () {
      that.$router.push('/picks')
    }

    function _setErrorMessage (message) {
      that.errorMessage = message
    }
    this.$nextTick(() => {
      paypal
        .Buttons({
          // Sets up the transaction when a payment button is clicked
          createOrder: _createOrder,
          onApprove: _onApprove,
          onError: function (error) {
            console.error(error)
            this.errorMessage = error.message || 'There was an issue processing your payment'
          },
          funding: {
            disallowed: [paypal.FUNDING.CREDIT]
          },

          style: {
            shape: 'rect',
            layout: 'vertical',
            color: 'gold',
            label: 'paypal'
          },
          message: {
            amount: 100
          }
        })
        .render('#paypal-button-container')
      that.cardField = paypal.CardFields({
        createOrder: _createOrder,
        onApprove: _onApprove,
        style: {
          input: {
            'font-size': '16px',
            'font-family': 'courier, monospace',
            'font-weight': 'lighter',
            color: '#333333'
          },
          '.invalid': { color: 'red' }
        }
      })
      console.log(`IsEligible ${that.cardField.isEligible()}`)
      if (that.cardField.isEligible()) {
        const nameField = that.cardField.NameField()
        nameField.render('#card-name-field-container')
        const numberField = that.cardField.NumberField()
        numberField.render('#card-number-field-container')
        const cvvField = that.cardField.CVVField({})
        cvvField.render('#card-cvv-field-container')
        const expiryField = that.cardField.ExpiryField({})
        expiryField.render('#card-expiry-field-container')
      } else {
        this.errorMessage = 'Card fields are not available at this time. Please reach out to support@stumpthespread.com'
      }
    })

    async function _onApprove (data, actions) {
      try {
        const response = await PurchaseRepository.capture(data)
        console.log(response)

        const orderData = response.data
        // A 200 means the API accepted the capture and has already granted the
        // membership. That includes the already-captured recovery path, whose
        // body is a PayPal error envelope with no purchase_units, so read
        // defensively and only fail on an explicitly DECLINED transaction.
        const purchaseUnit = (orderData.purchase_units && orderData.purchase_units[0]) || null
        const payments = purchaseUnit ? purchaseUnit.payments : null
        const transaction = payments
          ? (payments.captures && payments.captures[0]) || (payments.authorizations && payments.authorizations[0])
          : null

        if (transaction && transaction.status === 'DECLINED') {
          return _setErrorMessage('Your card was declined. Please try a different payment method.')
        }
        return _routeToSuccess()
      } catch (e) {
        console.log('error on approve')
        // Surface the API's message - it distinguishes a declined card from an
        // unapproved order from a genuine failure. e.message is only ever
        // "Request failed with status code NNN", which tells the buyer nothing.
        const serverData = e.response && e.response.data
        _setErrorMessage(
          (serverData && (serverData.error || serverData.msg)) ||
          'There was an issue processing your payment'
        )
      }
    }

    async function _createOrder (data) {
      try {
        const orderData = await PurchaseRepository.create({
          cart: [
            {
              id: that.dataPackage.id,
              quantity: 1,
              price: that.dataPackage.current_price
            }
          ]
        })

        if (orderData.data.id) {
          return orderData.data.id
        } else {
          const errorDetail = orderData.data.details[0]
          const errorMessage = errorDetail
            ? `${errorDetail.issue} ${errorDetail.description} (${orderData.data.debug_id})`
            : JSON.stringify(orderData)

          throw new Error(errorMessage)
        }
      } catch (error) {
        console.error(error)
        // A 401 is an expired session, not a payment failure. The axios
        // interceptor has already cleared the token and is redirecting to
        // /login, so don't blame the card or report it as a payment error.
        if (error.response && error.response.status === 401) {
          const authMessage = 'Your session has expired. Please sign in again to complete your purchase.'
          _setErrorMessage(authMessage)
          throw new Error(authMessage)
        }
        Raven.captureException(error, {
          extra: {
            packageId: that.dataPackage.id,
            price: that.dataPackage.current_price
          }
        })
        const serverData = error.response && error.response.data
        const message = (serverData && (serverData.error || serverData.msg)) ||
          'There was an issue processing your payment'
        _setErrorMessage(message)
        throw new Error(message)
      }
    }
  },
  computed: {
    buttonText () {
      return this.currentUser ? `Purchase $${this.dataPackage.current_price}` : `Log in to Purchase`
    },
    packageId () {
      return this.dataPackage.id
    },
    dataPackage () {
      return this.getPackage()
    },
    packages () {
      return this.$store.state.packages.filter(p => p.sports_id === this.selectedSport && !p.special)
    },
    currentUser () {
      return this.$store.state.currentUser
    }
  },
  methods: {
    onSportChange () {
      this.$store.commit('setCurrentPackage', this.packages[0])
    },
    emitSelection (evt) {
      this.$store.commit('setCurrentPackage', this.$store.getters.package(evt.target.value))
    },
    getPackage () {
      if (this.$store.state.currentPackage && this.$store.state.currentPackage.id) {
        if (this.$store.state.currentPackage.sports_id !== this.selectedSport) this.selectedSport = this.$store.state.currentPackage.sports_id
        return this.$store.state.currentPackage
      }
      const queryPackage = this.$route.query.package
        ? this.$store.getters.package(this.$route.query.package)
        : null
      return queryPackage || this.$store.getters.package(PACKAGES.ALL_MONTH) || FALLBACK_PACKAGE
    },
    purchase () {
      if (this.purchaseDisabled) return
      console.log('purchase click')
      if (!this.currentUser || !this.currentUser.id) {
        return this.$router.push({path: '/login', query: {package: this.dataPackage.id}})
      }
      this.purchaseDisabled = true
      this.cardField.submit({}).then((data) => {
        console.log(data)
      }).catch((error) => {
        console.log(error.message)
        if (error.message.indexOf('DECLINED') > 0) {
          this.errorMessage = 'Payment issue: Card was declined'
        } else if (error.message === 'INVALID_NUMBER') {
          this.errorMessage = 'Payment issue: Invalid card number'
        } else if (error.message === 'INVALID_EXPIRY') {
          this.errorMessage = 'Payment issue: Invalid expiration date'
        } else if (error.message === 'INVALID_CVV') {
          this.errorMessage = 'Payment Issue: Invalid CVV'
        } else {
          this.errorMessage = error.message || 'There was an issue processing your payment'
        }
        console.error(error)
      }).finally(() => {
        this.purchaseDisabled = false
      })
    }
  }
}
</script>
<style lang="css" scoped>
.Spacer-module_divider__ewqEj {
  align-items: center;
  margin: 0.3rem 0;
  display: flex;
  text-align: center;
}

.Spacer-module_divider__ewqEj:after,
.Spacer-module_divider__ewqEj:before {
  background-color: #c8c8c8;
  content: "";
  flex: 1;
  height: 1px;
  margin: 0 .675rem;
}

#card-field-submit-button:disabled {
  opacity: 0.5;
}

#card-field-submit-button {
  position: relative;
  border-radius: 1000px;
  color: #ffffff;
  cursor: pointer;
  display: inline-block;
  min-width: 6rem;
  text-align: center;
  -webkit-text-decoration: none;
  text-decoration: none;
  -webkit-transition: color 0.20s ease, background-color 0.20s ease, border-color 0.20s ease;
  transition: color 0.20s ease, background-color 0.20s ease, border-color 0.20s ease;
  border: 0.125rem solid #003087;
  color: #ffffff;
  font-family: PayPalOpen-Bold, "Helvetica Neue", Arial, sans-serif;
  font-size: 1.125rem;
  line-height: 1.5rem;
  font-weight: 400;
  background-color: #003087;
  padding: 0.625rem 1.875rem;
}

/*
https://www.paypalobjects.com/webstatic/en_US/developer/docs/css/cardfields.css
*/
.paypal-button-container {
  border-radius: 5px;
  background-color: #dcdce1;
  padding-bottom: 4px;
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
}

.card_container {
  border-radius: 5px;
  background-color: #dcdce1;
  /*padding: 20px;*/
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
}

.card_field {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  height: 40px;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}

.card_field_50 {
  width: 50%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  height: 40px;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}

.card_field_75 {
  width: 75%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 6px;
  margin-bottom: 16px;
  resize: vertical;
  height: 40px;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}

.row {
  display: -ms-flexbox;
  /* IE10 */
  display: flex;
  -ms-flex-wrap: wrap;
  /* IE10 */
  flex-wrap: wrap;
  margin: 0 -16px;
}

.col-25 {
  -ms-flex: 25%;
  /* IE10 */
  flex: 25%;
}

.col-50 {
  -ms-flex: 50%;
  /* IE10 */
  flex: 50%;
}

input[type=text],
select,
textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  margin-top: 4px;
  margin-bottom: 12px;
  resize: vertical;
  background: white;
  font-size: 17px;
  color: #3a3a3a;
  font-family: helvetica, tahoma, calibri, sans-serif;
}

input[type=submit] {
  background-color: #4CAF50;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.message_container {
  border-radius: 5px;
  background: #FFFFFF;
  font-size: 13px;
  font-family: monospace;
  padding: 20px;
}

#loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  display: block;
  opacity: 0.7;
  background-color: #fff;
  z-index: 99;
  text-align: center;
}

#loading-image {
  position: absolute;
  z-index: 15;
  top: 50%;
  left: 50%;
  margin: -100px 0 0 -150px;
}

.spinner {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  /* half width of the spinner gif */
  margin-top: -50px;
  /* half height of the spinner gif */
  text-align: center;
  z-index: 1234;
  overflow: auto;
  width: 100px;
  /* width of the spinner gif */
  height: 102px;
  /* height of the spinner gif +2px to fix IE8 issue */
}

.button_container {
  display: flex;
  justify-content: center;
}

button:hover {
  background-color: powderblue;
}

button {
  width: 229px;
  height: 49px;
  background: lightblue;
  border: 1px dotted black;
  font-size: 17px;
  color: #3a3a3a;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
}

.btn_small {
  width: 130px;
  height: 39px;
  background: lightblue;
  border: 1px dotted black;
  font-size: 14px;
  color: #3a3a3a;
}

.btn_small:hover {
  background-color: powderblue;
}

.paypal-button-message paypal-button-message-top {
  display: none !important;
  /* could override the message */
}
</style>



// WEBPACK FOOTER //
// Purchase.vue?503544de